export default __webpack_public_path__ + "static/daniel-steele-e4cc15a25d27179fda0c4b7d7f3f1d5b.png";